import { getCurrentPosition as getFallbackCurrentPosition } from "@irati/geolocation/src/services/fallbackPosition";
import { getNavigatorGeolocationOptions } from "./getNavigatorGeolocationOptions";
var convertGeolocationPositionToLatLng = function (position) {
    var _a = position.coords, latitude = _a.latitude, longitude = _a.longitude;
    return {
        lat: latitude,
        lng: longitude
    };
};
export var getCurrentPosition = function (options) {
    if (options === void 0) { options = { useFallback: true }; }
    return new Promise(function (resolve, reject) {
        if (!("geolocation" in navigator)) {
            return reject("geolocation.services.browserPosition.getCurrentPosition.notSupported");
        }
        navigator.geolocation.getCurrentPosition(function (position) {
            resolve({
                latLng: convertGeolocationPositionToLatLng(position),
                isFallback: false
            });
        }, function (errorData) {
            if (options.useFallback) {
                getFallbackCurrentPosition()
                    .then(function (fallbackPosition) { return resolve(fallbackPosition); })
                    .catch(function (fallbackError) { return reject(fallbackError); });
            }
            else {
                reject(errorData);
            }
        }, getNavigatorGeolocationOptions());
    });
};
